import { AWTermsOfUseAcknowledgement } from '@blk/awt-userpreference';
import { AGraphWrappedType, unwrapAGraphResponse } from '../../utils/AGraphWrapper';
import { transformTimestamps } from '../../utils/ApiUtils';
import { isAGraphEnabled } from './AGraphUtils';
import { userPreferenceApi } from './Base';
const path = '/v1/tou-acknowledgements';

/**
 * Retrieves the acknowledgments for the Terms of Use.
 *
 * @returns {Promise<AWTermsOfUseAcknowledgement[]>} A promise that resolves to the acknowledgments data.
 */
export interface GetTermsOfUseAcknowledgmentsParams {
  category: string;
  pkg?: string;
}

export async function getTermsOfUseAcknowledgments({ category, pkg }: GetTermsOfUseAcknowledgmentsParams) {
  const response = await userPreferenceApi.get<AGraphWrappedType<AWTermsOfUseAcknowledgement[], 'acknowledgements'>>(
    path,
    { params: { category, pkg } }
  );
  return unwrapAGraphResponse(response, 'acknowledgements');
}

/**
 * Sends a new acknowledgment to the user preference API.
 *
 * @param newAcknowledgement - The acknowledgment data to be posted.
 * @returns A promise that resolves with the posted acknowledgment data.
 */
export function postTermsOfUseAcknowledgment(newAcknowledgement: AWTermsOfUseAcknowledgement) {
  const payload = isAGraphEnabled()
    ? transformTimestamps(newAcknowledgement, ['createdAt'], 'stringify', {
        recursiveFieldPatterns: ['*'],
      })
    : newAcknowledgement;
  return userPreferenceApi.post<AWTermsOfUseAcknowledgement>(path, payload);
}
